"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPOTRadioButton = void 0;
var React = require("react");
require("./SPOTRadioButton.scss");
var SPOTRadioButton = function (props) {
    return (React.createElement("div", { className: "radio-button-component", "data-test": props.testId },
        React.createElement("input", { id: props.id, name: props.groupName, onChange: props.onChange, value: props.value, type: "radio", className: "format-radio-button ".concat(props.disabled ? "format-radio-button-disabled" : ""), disabled: props.disabled, checked: props.checked }),
        React.createElement("label", { htmlFor: props.elementLabel },
            !props.logo && props.elementLabel && (React.createElement("p", { className: "label-font format-text" },
                React.createElement("b", null, props.elementLabel))),
            props.logo && React.createElement("img", { className: "resize-prop-logo ".concat(props.disabled ? "payment-logo-disabled" : ""), src: props.logo, alt: "Logo" }))));
};
exports.SPOTRadioButton = SPOTRadioButton;
//# sourceMappingURL=SPOTRadioButton.js.map